import { CreatePetStepsEnum } from '@pages/hubs/Pets/enum/create-pet-steps-enum';

export const createFormStepper = [
  CreatePetStepsEnum.preStepPetType,
  // CreatePetStepsEnum.preStepSelectMethod,
  CreatePetStepsEnum.generalBase,
  CreatePetStepsEnum.generalSecond,
  CreatePetStepsEnum.coverPhoto,
  CreatePetStepsEnum.insuranceBase,
  CreatePetStepsEnum.share,
];

export const formStepper = {
  [CreatePetStepsEnum.preStepPetType]: {
    stepId: CreatePetStepsEnum.preStepPetType,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 0,
  },
  // --------- wait ai ----------
  // [CreatePetStepsEnum.preStepSelectMethod]: {
  //   stepId: CreatePetStepsEnum.preStepSelectMethod,
  //   isDisabled: false,
  //   isPassed: false,
  //   isSkip: false,
  //   id: 1,
  // },
  [CreatePetStepsEnum.generalBase]: {
    stepId: CreatePetStepsEnum.generalBase,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 1,
  },
  [CreatePetStepsEnum.generalSecond]: {
    stepId: CreatePetStepsEnum.generalSecond,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 2,
  },
  [CreatePetStepsEnum.coverPhoto]: {
    stepId: CreatePetStepsEnum.coverPhoto,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 3,
  },
  [CreatePetStepsEnum.insuranceBase]: {
    stepId: CreatePetStepsEnum.insuranceBase,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 4,
  },
  [CreatePetStepsEnum.share]: {
    stepId: CreatePetStepsEnum.share,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 5,
  },
  [CreatePetStepsEnum.congratulations]: {
    stepId: CreatePetStepsEnum.congratulations,
    isDisabled: false,
    isPassed: false,
    isSkip: false,
    id: 6,
  },
};
